import { useEffect, useState, useRef } from "react";
import { Modal, Button, Form, Card, Row, Col, Dropdown} from "react-bootstrap";
import Cropper from "react-easy-crop";
import getCroppedImg from "../utils/cropImage"; 
import './ModalUsuarioDetalle.css';
import API from "../api";
import axios from "axios";
import ParametrosSistema from "./ParametrosSistema";
import Notificaciones from "./Notificaciones";

const GestionUsuarios = () => {
  const refModales = useRef();
  const [usuarios, setUsuarios] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombre: "",
    apellidoP: "",
    apellidoM: "",
    genero: "",
    fechaNacimiento: "",
    correo: "",
    rol: "Funcional",
    estado: "Activo",
    clave: "",
    cargo: "",
    area: "",
    fechaIngreso: "",
    contrato: "",
    sueldoBase: "",
    jornada: "",
    sueldoBruto: "",
    rut: "",                  
    nacionalidad: ""            
  });

  useEffect(() => {
    fetch(`${API}/usuarios`)
      .then((res) => res.json())
      .then((data) => setUsuarios(data));
  }, []);

  useEffect(() => {
    fetch(`${API}/usuarios_externos`)
      .then(res => res.json())
      .then(data => setUsuariosExternos(data))
      .catch(err => console.error("Error al cargar usuarios externos:", err));
  }, []);

  const usuariosFiltrados = usuarios.filter((u) => {
    const nombreCompleto = `${u["Nombre"] || ""} ${u["Apellido Paterno"] || ""} ${u["Apellido Materno"] || ""}`.toLowerCase();
    return (
      (u["Usuario"] || "").toLowerCase().includes(busqueda.toLowerCase()) ||
      nombreCompleto.includes(busqueda.toLowerCase())
    );
  });

  const obtenerUsuarios = () => {
    fetch(`${API}/usuarios`)
      .then((res) => res.json())
      .then((data) => setUsuarios(data));
  };

  const obtenerUsuariosExternos = () => {
    fetch(`${API}/usuarios_externos`)
      .then((res) => res.json())
      .then((data) => setUsuariosExternos(data));
  };

  const [formularioTocado, setFormularioTocado] = useState(false);

  const [mostrarAccionModal, setMostrarAccionModal] = useState(false);
  const [usuarioAccion, setUsuarioAccion] = useState(null);
  
  const [mostrarWizard, setMostrarWizard] = useState(false);
  const [imagenCedula, setImagenCedula] = useState(null);

  const [mostrarDetalleUsuario, setMostrarDetalleUsuario] = useState(false);
  const [vistaUsuarios, setVistaUsuarios] = useState("planta"); // opciones: 'planta' o 'externos'
  const [procesandoImagen, setProcesandoImagen] = useState(false);
  const [datosExtraidos, setDatosExtraidos] = useState(null);
  const [pasoActual, setPasoActual] = useState(1);

  const [sueldoFormateado, setSueldoFormateado] = useState("");

  const [erroresFormulario, setErroresFormulario] = useState({});
  const [mensajeError, setMensajeError] = useState("");

  const validarCamposFormulario = () => {
    const camposObligatorios = [
      "fechaIngreso", "area", "cargo", "jornadaLaboral",
      "rol", "estado", "tipoContrato", "sueldoBase",
      "correo", "clave"
    ];

    const nuevosErrores = {};
    camposObligatorios.forEach((campo) => {
      if (!nuevoUsuario[campo] || nuevoUsuario[campo].toString().trim() === "") {
        nuevosErrores[campo] = true;
      }
    });

    setErroresFormulario(nuevosErrores);
    setMensajeError(Object.keys(nuevosErrores).length > 0 ? "Faltan datos por completar" : "");
    return Object.keys(nuevosErrores).length === 0;
  };

  const verificarRutExistente = async (rut) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/verificar_rut/${rut}`);
      const data = await res.json();
      return data.existe;
    } catch (error) {
      console.error("Error al verificar RUT:", error);
      return false; // Si hay error, permitir avanzar igual por precaución (puedes cambiar esto)
    }
  };
  const inputFileRef = useRef(null);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [cambiosRealizados, setCambiosRealizados] = useState(false);

  const [listaAreas, setListaAreas] = useState([]);
  useEffect(() => {
    const obtenerAreas = async () => {
      try {
        const response = await fetch(`${API}/areas`);
        const data = await response.json();
        setListaAreas(data);
      } catch (error) {
        console.error("Error al cargar áreas:", error);
      }
    };

    obtenerAreas();
  }, []);

  const [listaCargos, setListaCargos] = useState([]);

  useEffect(() => {
    const obtenerCargos = async () => {
      try {
        const response = await fetch(`${API}/cargos`);
        const data = await response.json();
        setListaCargos(data);
      } catch (error) {
        console.error("Error al cargar cargos:", error);
      }
    };

    obtenerCargos();
  }, []);

  const [listaRoles, setListaRoles] = useState([]);

  useEffect(() => {
    const obtenerRoles = async () => {
      try {
        const response = await fetch(`${API}/roles`);
        const data = await response.json();
        console.log("🧪 Resultado del endpoint /roles:", data); // Agrega esto
        setListaRoles(data);
      } catch (error) {
        console.error("Error al cargar roles:", error);
      }
    };

    obtenerRoles();
  }, []);


  const [listaJornadas, setListaJornadas] = useState([]);

  useEffect(() => {
    const obtenerJornadas = async () => {
      try {
        const response = await fetch(`${API}/jornadas`);
        const data = await response.json();
        setListaJornadas(data);
      } catch (error) {
        console.error("Error al cargar jornadas:", error);
      }
    };

    obtenerJornadas();
  }, []);

  const [listaTiposContrato, setListaTiposContrato] = useState([]);

  useEffect(() => {
    const obtenerTiposContrato = async () => {
      try {
        const response = await fetch(`${API}/tiposcontrato`);
        const data = await response.json();
        setListaTiposContrato(data);
      } catch (error) {
        console.error("Error al cargar tipos de contrato:", error);
      }
    };

    obtenerTiposContrato();
  }, []);

  const manejarCambioCampo = (campo, nuevoValor) => {
    const original = usuarioSeleccionado?.[campo] || "";
    if (nuevoValor !== original) {
      setCambiosRealizados(true);
    }
    setUsuarioEditado({ ...usuarioEditado, [campo]: nuevoValor });
  };
  const [cvArchivo, setCvArchivo] = useState(null); // Para guardar el archivo CV
  const [cedulaFrente, setCedulaFrente] = useState(null);
  const [cedulaReverso, setCedulaReverso] = useState(null);
  const [contratoArchivo, setContratoArchivo] = useState(null);
  const [mostrarModalExternos, setMostrarModalExternos] = useState(false);
  const [modoIndividual, setModoIndividual] = useState(false);
  const [solicitudesPendientes, setSolicitudesPendientes] = useState([]);

  const obtenerSolicitudesPendientes = async () => {
    try {
      const res = await axios.get(`${API}/solicitudes_rrhh`);
      const pendientes = res.data.filter(s => s.Estado === "Pendiente");
      setSolicitudesPendientes(pendientes);
    } catch (err) {
      console.error("Error al obtener solicitudes:", err);
    }
  };

  // Por arriba, dentro del componente (junto a tus useState)
  const resetFormularioIndividual = () => {
    setNombreExt("");
    setApellidoPExt("");
    setApellidoMExt("");
    setCelularExt("");
    setCorreoParte1("");
    setCorreoDominio("gmail.com"); // dominio por defecto
    // si quieres volver a Chile +569 por defecto:
    const chile = paises.find(p => p.iso === "cl") || paises[0];
    setPrefijoPais(chile);
  };

  useEffect(() => {
    obtenerSolicitudesPendientes();
  }, []);

  const [correoParte1, setCorreoParte1] = useState("");
  const [correoDominio, setCorreoDominio] = useState("gmail.com");

  const [nombreExt, setNombreExt] = useState("");
  const [apellidoPExt, setApellidoPExt] = useState("");
  const [apellidoMExt, setApellidoMExt] = useState("");
  const [prefijoPais, setPrefijoPais] = useState({ codigo: "+56", nombre: "Chile", iso: "cl" });
  const [usuariosExternos, setUsuariosExternos] = useState([]);

  const [modoEdicion, setModoEdicion] = useState(false);
  const [usuarioEditado, setUsuarioEditado] = useState(null);

  const guardarCambiosUsuario = async () => {
    const datosParaEnviar = {
      ...usuarioEditado,
      tipo: vistaUsuarios
    };

    try {

      const response = await fetch(`${API}/actualizar_usuario`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datosParaEnviar),
      });

      const data = await response.json();

      if (response.ok) {
        alert("Cambios guardados correctamente");
        setModoEdicion(false);
        setMostrarDetalleUsuario(false);
        setCambiosRealizados(false);
        if (vistaUsuarios === "planta") {
          obtenerUsuarios();
        } else {
          obtenerUsuariosExternos();
        }
      } else {
        alert(`Error al guardar cambios: ${data.error}`);
      }
    } catch (error) {
      console.error("❌ Error en fetch:", error);
      alert("Error de conexión al guardar los cambios.");
    }
  };

  useEffect(() => {
    if (usuarioSeleccionado) {
      console.log("👤 Usuario seleccionado:", usuarioSeleccionado);
      setUsuarioEditado({ ...usuarioSeleccionado });
    }
  }, [usuarioSeleccionado]);

  const paises = [
    { nombre: "Chile", codigo: "+56", iso: "cl" },
    { nombre: "Argentina", codigo: "+54", iso: "ar" },
    { nombre: "Perú", codigo: "+51", iso: "pe" },
    { nombre: "Italia", codigo: "+39", iso: "it" },
    { nombre: "Venezuela", codigo: "+58", iso: "ve" },
  ];

  const [celularExt, setCelularExt] = useState("");
  const [mostrarModalMultiples, setMostrarModalMultiples] = useState(false);
  const [archivoExcelCargado, setArchivoExcelCargado] = useState(null);

  const procesarArchivoExcel = async () => {
    if (!archivoExcelCargado) {
      alert("Primero debes cargar un archivo Excel.");
      return;
    }

    const formData = new FormData();
    formData.append("archivo", archivoExcelCargado);

    console.log("📤 Enviando archivo al backend...");
    console.log("📎 Nombre del archivo:", archivoExcelCargado.name);

    try {

      const response = await fetch(`${API}/carga_masiva_usuarios_externos`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json(); // 👈 primero obtenemos la respuesta
      console.log("📥 Respuesta recibida:", data);

      if (response.ok) {
        alert(data.mensaje);
        setMostrarModalMultiples(false); // cerrar modal si todo ok
      } else {
        alert(`Error: ${data.error || "No se pudo procesar el archivo."}`);
      }
    } catch (error) {
      console.error("❌ Error al enviar el archivo:", error);
      alert("Error de conexión con el servidor.");
    }
  };

  const enviarCorreo = () => {
    const payload = {
      nombre: nombreExt,
      apellidoP: apellidoPExt,
      apellidoM: apellidoMExt,
      correo: `${correoParte1}@${correoDominio}`,
      celular: `${prefijoPais.codigo}${celularExt}` 
    };

    fetch(`${API}/enviar_correo_usuario_externo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        if (data.mensaje) {
          alert("Correo enviado correctamente");
          setMostrarModalExternos(false);
          setModoIndividual(false);
        } else {
          alert("Error al enviar correo");
        }
      });
  };

  const handleEnviarIndividual = async () => {
    try {
      await enviarCorreo();        // tu función actual de envío
      resetFormularioIndividual(); // ← aquí vaciamos el formulario
      // Si quieres cerrar el modo individual después de enviar:
      // setModoIndividual(false);
      // Si usas validación visual, podrías también limpiar errores aquí.
    } catch (err) {
      console.error("Error al enviar correo:", err);
      // opcional: mostrar alerta/toast de error
    }
  };

  const [tieneExamenes, setTieneExamenes] = useState(null); // null, true o false
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const examenesDisponibles = [
  "Altura Fisica",
  "Aversion al riesgo",
  "Evaluacion Salud Estandar",
  "Evaluacion Salud Full",
  "Exposicion Metal Plomo",
  ];
  const [examenesSeleccionados, setExamenesSeleccionados] = useState([]);
  const [archivosExamenes, setArchivosExamenes] = useState({});

  const [mostrarConfirmacionEliminar, setMostrarConfirmacionEliminar] = useState(false);
  const [usuarioAEliminar, setUsuarioAEliminar] = useState(null);

  const confirmarEliminacionUsuario = async () => {
    try {
      const tipo = vistaUsuarios === "planta" ? "planta" : "externo";

      const response = await fetch(`${API}/eliminar_usuario/${tipo}/${usuarioAEliminar.Usuario}`, {
        method: "DELETE",
      });

      const data = await response.json();

      if (response.ok) {
        alert("Usuario eliminado correctamente.");
        if (tipo === "planta") {
          setUsuarios(usuarios.filter((u) => u.Usuario !== usuarioAEliminar.Usuario));
        } else {
          setUsuariosExternos(usuariosExternos.filter((u) => u.Usuario !== usuarioAEliminar.Usuario));
        }
      } else {
        alert("Error al eliminar el usuario: " + data.error);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Ocurrió un error al intentar eliminar el usuario.");
    } finally {
      setMostrarConfirmacionEliminar(false);
    }
  };

  const cerrarWizard = () => {
    setMostrarWizard(false);
    setImagenCedula(null);
    setDatosExtraidos(null);
    setPasoActual(1);
    setProcesandoImagen(false);
    setMostrarFormulario(false);

    setNuevoUsuario({
      nombre: "",
      apellidoP: "",
      apellidoM: "",
      genero: "",
      fechaNacimiento: "",
      correo: "",
      rol: "Funcional",
      estado: "Activo",
      clave: "",
      cargo: "",
      area: "",
      fechaIngreso: "",
      contrato: "",
      sueldoBase: "",
      jornadaLaboral: "",
      sueldoBruto: "",
      rut: "",
      nacionalidad: ""
    });
  };


  const guardarNuevoUsuario = () => {
    const campos = {
      nombre: nuevoUsuario.nombre,
      apellidoP: nuevoUsuario.apellidoP,
      apellidoM: nuevoUsuario.apellidoM,
      genero: nuevoUsuario.genero,
      fechaNacimiento: nuevoUsuario.fechaNacimiento,
      correo: nuevoUsuario.correo,
      rol: nuevoUsuario.rol,
      estado: nuevoUsuario.estado,
      clave: nuevoUsuario.clave,
      cargo: nuevoUsuario.cargo,
      area: nuevoUsuario.area,
      fechaIngreso: nuevoUsuario.fechaIngreso,
      tipoContrato: nuevoUsuario.tipoContrato,
      jornadaLaboral: nuevoUsuario.jornadaLaboral,
      sueldoBase: nuevoUsuario.sueldoBase
    };
  
    // Validación: buscar el campo vacío
    for (const [campo, valor] of Object.entries(campos)) {
      if (!valor || valor === "") {
        alert(`El campo "${campo}" está vacío. Por favor, complétalo.`);
        return;
      }
    }
  
    // Si todo bien, generar usuario
    const sufijo = Math.floor(1000 + Math.random() * 9000);
    const usuario = `${nuevoUsuario.nombre[0]}${nuevoUsuario.apellidoP[0]}${nuevoUsuario.apellidoM[0]}-MO${sufijo}`;

    const formatearFecha = (fechaStr) => {
      if (!fechaStr) return "";
      const [anio, mes, dia] = fechaStr.split("-");
      return `${dia}/${mes}/${anio}`;
    };

    const nuevo = {
      Nombre: nuevoUsuario.nombre,
      "Apellido Paterno": nuevoUsuario.apellidoP,
      "Apellido Materno": nuevoUsuario.apellidoM,
      Género: nuevoUsuario.genero,
      FechaNacimiento: nuevoUsuario.fechaNacimiento,
      Correo: nuevoUsuario.correo,
      Usuario: usuario,
      RolUsuario: nuevoUsuario.rol,
      Estado: nuevoUsuario.estado,
      ClaveAcceso: nuevoUsuario.clave,
      Cargo: nuevoUsuario.cargo,
      "Área o Departamento": nuevoUsuario.area,
      FechaIngreso: formatearFecha(nuevoUsuario.fechaIngreso),
      TipoContrato: nuevoUsuario.tipoContrato,
      SueldoBase: parseInt(nuevoUsuario.sueldoBase),
      JornadaLaboral: nuevoUsuario.jornadaLaboral
    };

    fetch(`${API}/agregar-usuario`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(nuevo),
    })

      .then((res) => res.json())
      .then((resp) => {
        alert(resp.mensaje);
        setUsuarios([...usuarios, nuevo]);
        setNuevoUsuario({
          nombre: "", apellidoP: "", apellidoM: "", genero: "", fechaNacimiento: "", correo: "",
          rol: "Funcional", estado: "Activo", clave: "", cargo: "", area: "", fechaIngreso: "",
          tipoContrato: "", sueldoBase: "", jornadaLaboral: ""
        });
      });
  };

  const [zoom, setZoom] = useState(1);                         // Zoom de la imagen
  const [mostrarRecorte, setMostrarRecorte] = useState(false); // Muestra/oculta el recortador
  const [previsualizacion, setPrevisualizacion] = useState(null); // Imagen recortada lista para mostrar
  const [imagenRecorte, setImagenRecorte] = useState(null);
  const [recorte, setRecorte] = useState({ x: 0, y: 0 });
  const [areaRecortada, setAreaRecortada] = useState(null);

  const manejarCambioFoto = (e) => {
    const archivo = e.target.files[0];
    if (archivo) {
      setImagenRecorte(archivo);
      setMostrarRecorte(true);
    }
  };

  const confirmarRecorteImagen = async () => {
    try {
      const imagenCortada = await getCroppedImg(
        URL.createObjectURL(imagenRecorte),
        areaRecortada
      );
      setPrevisualizacion(imagenCortada);
      setMostrarRecorte(false);
    } catch (error) {
      console.error("Error al recortar la imagen", error);
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold fs-4 text-center w-100">Gestión de Usuarios</h2>
      </div>

      {/* NUEVAS PESTAÑAS */}
      <ul className="nav nav-tabs justify-content-center mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${vistaUsuarios === "planta" ? "active" : ""}`}
            onClick={() => setVistaUsuarios("planta")}
          >
            <i className="bi bi-people-fill me-2"></i>Usuarios de Planta
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${vistaUsuarios === "externos" ? "active" : ""}`}
            onClick={() => setVistaUsuarios("externos")}
          >
            <i className="bi bi-person-workspace me-2"></i>Usuarios Externos
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${vistaUsuarios === "sistema" ? "active" : ""}`}
            onClick={() => setVistaUsuarios("sistema")}
          >
            <i className="bi bi-pc-display-horizontal me-2"></i>Parámetros de Sistema
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${vistaUsuarios === "notificaciones" ? "active" : ""}`}
            onClick={() => setVistaUsuarios("notificaciones")}
          >
            <span className="position-relative me-2">
              <i className="bi bi-bell-fill fs-5"></i>
              {solicitudesPendientes.length > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "0.65rem" }}
                >
                  {solicitudesPendientes.length}
                </span>
              )}
            </span>
            Notificaciones
          </button>
        </li>
      </ul>

      {/* CONTENIDO DE USUARIOS */}
      {(vistaUsuarios === "planta" || vistaUsuarios === "externos") && (
        <>
          <div className="d-flex justify-content-center align-items-center mb-4 gap-3">
            <input
              type="text"
              className="form-control me-3"
              style={{ maxWidth: "60%" }}
              placeholder="Buscar por Usuario o Nombre Completo..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
            <Button
              className="btn btn-primary"
              onClick={() => {
                if (vistaUsuarios === "planta") {
                  setMostrarWizard(true);
                } else if (vistaUsuarios === "externos") {
                  setMostrarModalExternos(true);
                }
              }}
            >
              + Usuario Nuevo
            </Button>
          </div>

          {vistaUsuarios === "planta" ? (
            <div className="table-responsive">
              <table className="table table-striped table-bordered shadow-sm rounded align-middle" style={{ tableLayout: "auto", width: "90%", margin: "0 auto" }}>
                <thead className="table-dark text-white text-center">
                  <tr>
                    <th scope="col">Usuario</th>
                    <th scope="col">Nombre Completo</th>
                    <th scope="col">Área / Departamento</th>
                    <th scope="col">Rol</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {usuariosFiltrados.map((u, index) => (
                    <tr key={index} className="bg-white">
                      <td
                        style={{ cursor: "pointer", color: "#0d6efd" }}
                        onClick={() => {
                          setUsuarioSeleccionado(u);
                          setMostrarDetalleUsuario(true);
                        }}
                      >
                        {u["Usuario"]}
                      </td>
                      <td>{`${u["Nombre"]} ${u["Apellido Paterno"]} ${u["Apellido Materno"]}`}</td>
                      <td>{u["Área o Departamento"]}</td>
                      <td>{u["RolUsuario"]}</td>
                      <td className="text-center">
                        <span
                          className={`badge rounded-pill px-3 py-2 fw-semibold ${
                            u["Estado"] === "Activo"
                              ? "bg-success"
                              : "bg-secondary"
                          }`}
                        >
                          {u["Estado"]}
                        </span>
                      </td>
                      <td className="text-center">
                        <i
                          className="bi bi-pencil-square text-primary"
                          style={{ cursor: "pointer", fontSize: "1.2rem" }}
                          title="Acciones"
                          onClick={() => {
                            setUsuarioAccion(u);
                            setMostrarAccionModal(true);
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="table-responsive mt-4">
              <table className="table table-striped table-bordered shadow-sm text-center align-middle">
                <thead className="table-dark text-white">
                  <tr>
                    <th>Usuario</th>
                    <th>Nombre Completo</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {usuariosExternos.map((u, index) => (
                    <tr key={index}>
                      <td
                        style={{ cursor: "pointer", color: "#0d6efd" }}
                        title="Ver detalles"
                        onClick={() => {
                          setUsuarioSeleccionado(u);
                          setMostrarDetalleUsuario(true);
                        }}
                      >
                        {u.Usuario}
                      </td>
                      <td>{`${u.Nombre} ${u["Apellido Paterno"]} ${u["Apellido Materno"]}`}</td>
                      <td>
                        <i
                          className="bi bi-pencil-square text-primary"
                          style={{ cursor: "pointer", fontSize: "1.2rem" }}
                          title="Editar usuario"
                          onClick={() => {
                            setUsuarioAccion(u);
                            setMostrarAccionModal(true);
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* PARAMETROS SISTEMA */}
      {vistaUsuarios === "sistema" && <ParametrosSistema />}

      {/* NOTIFICACIONES */}
      {vistaUsuarios === "notificaciones" && (
        <Notificaciones
          solicitudes={solicitudesPendientes}
          actualizarSolicitudes={obtenerSolicitudesPendientes}
        />
      )}

    {/* MODAL AGREGAR 2.0 */}
    {/* MODAL PASO 1: Cargar Cédula */}
    <Modal show={mostrarWizard && pasoActual === 1} onHide={cerrarWizard} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Paso 1: Cargar Cédula de Identidad</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!imagenCedula && (
          <div
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const archivo = e.dataTransfer.files[0];
              if (archivo && archivo.type.startsWith("image/")) {
                setImagenCedula(URL.createObjectURL(archivo));
              }
            }}
            style={{
              border: "2px dashed #6c757d",
              borderRadius: "10px",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer"
            }}
          >
            <p className="mb-3">Arrastra aquí la imagen de la cédula o selecciónala manualmente:</p>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              ref={inputFileRef}
              onChange={(e) => {
                const archivo = e.target.files[0];
                if (archivo && archivo.type.startsWith("image/")) {
                  setImagenCedula(URL.createObjectURL(archivo));
                }
              }}
            />
          </div>
        )}

        {imagenCedula && (
          <div className="mt-4 text-center">
            <p className="fw-bold">Vista previa:</p>
            <img src={imagenCedula} alt="Cédula" className="img-fluid rounded shadow-sm mb-3" />
            <div>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  setImagenCedula(null);
                  setDatosExtraidos(null);
                  if (inputFileRef.current) {
                    inputFileRef.current.value = "";
                  }
                }}
              >
                Quitar Imagen
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={cerrarWizard}>Cancelar</Button>
        <Button
          variant="primary"
          disabled={!imagenCedula || procesandoImagen}
          onClick={async () => {
            setProcesandoImagen(true);
            setDatosExtraidos(null);

            try {
              const formData = new FormData();
              const response = await fetch(imagenCedula);
              const blob = await response.blob();
              formData.append("imagen", blob, "cedula.jpg");

              const res = await fetch(`${API}/extraer-datos-cedula`, {
                method: "POST",
                body: formData,
              });
              const datos = await res.json();
              setDatosExtraidos(datos);
              setPasoActual(2);
            } catch (error) {
              console.error("Error al procesar imagen:", error);
              alert("Ocurrió un error al procesar la imagen.");
            }

            setProcesandoImagen(false);
          }}
        >
          {procesandoImagen ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            "Siguiente"
          )}
        </Button>
      </Modal.Footer>
    </Modal>

    {/* MODAL PASO 2.1: Datos extraídos + formulario */}
    <Modal show={mostrarWizard && pasoActual === 2} onHide={cerrarWizard} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Paso 2: Confirmar Datos Extraídos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {mensajeError && (
          <div className="text-danger fw-bold mb-3 text-center">
            ⚠️ {mensajeError}
          </div>
        )}
        {datosExtraidos && (
          <>
            <h5 className="fw-bold mb-4 text-center">Datos extraídos de la cédula</h5>
            <Row className="g-3 mb-4">
              {[
                ["Nombres", datosExtraidos.nombre],
                ["Apellido Paterno", datosExtraidos.apellidoP],
                ["Apellido Materno", datosExtraidos.apellidoM],
                ["RUN", datosExtraidos.rut],
                ["Nacionalidad", datosExtraidos.nacionalidad],
                ["Sexo", datosExtraidos.sexo],
                ["Fecha de Nacimiento", datosExtraidos.fechaNacimiento],
                ["Fecha de Vencimiento", datosExtraidos.fechaVencimiento],
              ].map(([label, value], idx) => (
                <Col md={3} key={idx}>
                  <Card className="shadow-sm">
                    <Card.Body className="p-2">
                      <div className="fw-bold text-dark mb-1">{label}</div>
                      <div className="text-secondary">{value}</div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}

        {mostrarFormulario && (
          <>
            <hr className="my-4" />
            <h5 className="fw-bold mb-3 text-center">Completa los datos restantes</h5>
            <Form>
              <Row className="mb-3">
                <Col md={3}><Form.Label className="fw-bold">Fecha Ingreso</Form.Label><Form.Control type="date" value={nuevoUsuario.fechaIngreso} isInvalid={erroresFormulario.fechaIngreso} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, fechaIngreso: e.target.value })} /></Col>
                <Col md={3}><Form.Label className="fw-bold">Área</Form.Label><Form.Select value={nuevoUsuario.area} isInvalid={erroresFormulario.area} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, area: e.target.value })}><option value="">Seleccionar</option>{listaAreas.map((area) => (<option key={area._id} value={area.nombre}>{area.nombre}</option>))}</Form.Select></Col>
                <Col md={3}><Form.Label className="fw-bold">Cargo</Form.Label><Form.Select value={nuevoUsuario.cargo} isInvalid={erroresFormulario.cargo} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, cargo: e.target.value })}><option value="">Seleccionar</option>{listaCargos.filter((c) => c.area_nombre === nuevoUsuario.area).map((cargo) => (<option key={cargo._id} value={cargo.nombre}>{cargo.nombre}</option>))}</Form.Select></Col>
                <Col md={3}><Form.Label className="fw-bold">Jornada</Form.Label><Form.Select value={nuevoUsuario.jornadaLaboral} isInvalid={erroresFormulario.jornadaLaboral} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, jornadaLaboral: e.target.value })}><option value="">Seleccionar</option>{listaJornadas.map((j, i) => <option key={i}>{j.nombre}</option>)}</Form.Select></Col>
              </Row>
              <Row>
                <Col md={3}><Form.Label className="fw-bold">Rol Usuario</Form.Label><Form.Select value={nuevoUsuario.rol} isInvalid={erroresFormulario.rol} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, rol: e.target.value })}><option value="">Seleccionar</option>{listaRoles.map((rol) => (<option key={rol._id} value={rol.nombre}>{rol.nombre}</option>))}</Form.Select></Col>
                <Col md={3}><Form.Label className="fw-bold">Estado</Form.Label><Form.Select value={nuevoUsuario.estado} isInvalid={erroresFormulario.estado} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, estado: e.target.value })}><option>Activo</option><option>Inactivo</option></Form.Select></Col>
                <Col md={3}><Form.Label className="fw-bold">Tipo Contrato</Form.Label><Form.Select value={nuevoUsuario.tipoContrato} isInvalid={erroresFormulario.tipoContrato} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, tipoContrato: e.target.value })}><option value="">Seleccionar</option>{listaTiposContrato.map((t, i) => <option key={i}>{t.nombre}</option>)}</Form.Select></Col>
                <Col md={3}><Form.Label className="fw-bold">Sueldo Base</Form.Label><Form.Control type="number" value={nuevoUsuario.sueldoBase} isInvalid={erroresFormulario.sueldoBase} onChange={(e) => { const soloNumeros = e.target.value.replace(/\D/g, ""); setNuevoUsuario({ ...nuevoUsuario, sueldoBase: soloNumeros }); const formateado = new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(soloNumeros || 0); setSueldoFormateado(formateado); }} /><div className="text-muted mt-1" style={{ fontSize: "0.85rem" }}>{sueldoFormateado && `Formato: ${sueldoFormateado}`}</div></Col>
              </Row>
              <Row>
                <Col md={3}><Form.Label className="fw-bold">Correo</Form.Label><Form.Control type="email" value={nuevoUsuario.correo} isInvalid={erroresFormulario.correo} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, correo: e.target.value })} /></Col>
                <Col md={3}><Form.Label className="fw-bold">Clave Acceso</Form.Label><Form.Control type="text" value={nuevoUsuario.clave} isInvalid={erroresFormulario.clave} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, clave: e.target.value })} /></Col>
              </Row>
            </Form>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={cerrarWizard}>Cancelar</Button>
        <Button
          variant="success"
          onClick={async () => {
            const rut = datosExtraidos?.rut;
            
            if (!mostrarFormulario) {
              // Validar si ya existe el RUT antes de permitir avanzar
              const existe = await verificarRutExistente(rut);
              if (existe) {
                alert("⚠️ Ya existe un usuario con este RUT.");
                return;
              }

              setNuevoUsuario((prev) => ({
                ...prev,
                nombre: datosExtraidos.nombre || "",
                apellidoP: datosExtraidos.apellidoP || "",
                apellidoM: datosExtraidos.apellidoM || "",
                genero: datosExtraidos.sexo || "",
                fechaNacimiento: datosExtraidos.fechaNacimiento || "",
                rut: datosExtraidos.rut || "",
                nacionalidad: datosExtraidos.nacionalidad || "",
                correo: "", cargo: "", area: "", fechaIngreso: "", tipoContrato: "", sueldoBase: "", jornadaLaboral: "", rol: "Funcional", estado: "Activo", clave: ""
              }));
              setMostrarFormulario(true);
            } else {
              const esValido = validarCamposFormulario();
              if (!esValido) return;
              setPasoActual(3);
            }
          }}
        >
          Continuar
        </Button>
      </Modal.Footer>
    </Modal>

    {/* MODAL PASO 3: Cargar Documentos del Usuario */}
    <Modal show={mostrarWizard && pasoActual === 3} onHide={cerrarWizard} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Paso 3: Cargar Documentos del Usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="fw-bold mb-4 text-center">Carga de Documentos Obligatorios</h5>
        <Form>
        {/* FOTO DEL USUARIO */}
        <h6 className="titulos-cargadoc mb-3">Fotografía del Usuario</h6>
        <Row className="mb-4 justify-content-left">
          <Col md={6}>
            <Form.Group controlId="formFotoPerfil" className="mb-3">
              <Form.Label className="fw-bold">Foto del Usuario (JPG o PNG)</Form.Label>
              <Form.Control type="file" accept=".jpg,.jpeg,.png" onChange={manejarCambioFoto} />
            </Form.Group>

            {mostrarRecorte && (
              <>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: 300,
                    background: "#333",
                  }}
                >
                  <Cropper
                    image={URL.createObjectURL(imagenRecorte)}
                    crop={recorte}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setRecorte}
                    onZoomChange={setZoom}
                    onCropComplete={(_, areaRecortada) => setAreaRecortada(areaRecortada)}
                  />
                </div>
                <Form.Label className="fw-bold mt-2">Zoom</Form.Label>
                <Form.Range
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(e.target.value)}
                />
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <Button variant="success" onClick={confirmarRecorteImagen}>
                    Confirmar Recorte
                  </Button>
                  <Button variant="secondary" onClick={() => setMostrarRecorte(false)}>
                    Cancelar
                  </Button>
                </div>
              </>
            )}
          </Col>

          {/* Previsualización en la misma fila */}
          {previsualizacion && (
            <Col md="auto" className="d-flex align-items-center">
              <div className="text-center">
                <h6 className="fw-bold">Previsualización:</h6>
                <img
                  src={previsualizacion}
                  alt="Previsualización"
                  className="img-thumbnail"
                  style={{ width: 200, height: 200, objectFit: "cover" }}
                />
              </div>
            </Col>
          )}
        </Row>

          {/* CÉDULA DE IDENTIDAD */}
          <h6 className="titulos-cargadoc mb-3">Cédula de Identidad</h6>
          <Row className="mb-4 justify-content-center">
            <Col md={6}>
              <Form.Group controlId="formFileCedulaFrente" className="mb-3">
                <Form.Label>Anverso</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => setCedulaFrente(e.target.files[0])}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFileCedulaReverso" className="mb-3">
                <Form.Label>Reverso</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => setCedulaReverso(e.target.files[0])}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* DOCUMENTOS EXTRAS */}
          <h6 className="titulos-cargadoc mb-3">Documentos Extras</h6>
          <Row className="mb-4 justify-content-center">
            <Col md={6}>
              <Form.Group controlId="formFileCV" className="mb-3">
                <Form.Label>Currículum Vitae (PDF o Word)</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setCvArchivo(e.target.files[0])}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFileContrato" className="mb-3">
                <Form.Label>Contrato Firmado</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setContratoArchivo(e.target.files[0])}
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />
          <Row className="align-items-center">
            <Col md={4}>
              <Form.Label className="fw-bold">¿Usuario tiene exámenes preocupacionales?</Form.Label>
            </Col>
            <Col md={2}>
              <Form.Check
                type="radio"
                label="Sí"
                name="examenPreocupacional"
                onChange={() => setTieneExamenes(true)}
                checked={tieneExamenes === true}
              />
            </Col>
            <Col md={2}>
              <Form.Check
                type="radio"
                label="No"
                name="examenPreocupacional"
                onChange={() => setTieneExamenes(false)}
                checked={tieneExamenes === false}
              />
            </Col>
          </Row>

          {tieneExamenes && (
            <>
              <Row className="mt-3">
                <Col md={6}>
                  <Form.Label className="fw-bold">Selecciona uno o más exámenes realizados:</Form.Label>
                  <Dropdown show={mostrarDropdown} onToggle={() => setMostrarDropdown(!mostrarDropdown)}>
                    <Dropdown.Toggle variant="outline-primary" className="w-100 text-start">
                      {examenesSeleccionados.length > 0
                        ? `${examenesSeleccionados.length} examen(es) seleccionado(s)`
                        : "Seleccionar exámenes"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100 p-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {examenesDisponibles.map((examen) => (
                        <Form.Check
                          key={examen}
                          type="checkbox"
                          id={`check-${examen}`}
                          label={examen}
                          className="mb-2"
                          checked={examenesSeleccionados.includes(examen)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setExamenesSeleccionados([...examenesSeleccionados, examen]);
                            } else {
                              setExamenesSeleccionados(examenesSeleccionados.filter((item) => item !== examen));
                              const copia = { ...archivosExamenes };
                              delete copia[examen];
                              setArchivosExamenes(copia);
                            }
                          }}
                        />
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>

              <Row className="mt-4">
                {examenesSeleccionados.map((examen) => (
                  <Col md={6} key={examen}>
                    <Form.Group controlId={`archivo-${examen}`} className="mb-3">
                      <Form.Label className="fw-bold">Subir archivo: {examen}</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) =>
                          setArchivosExamenes({
                            ...archivosExamenes,
                            [examen]: e.target.files[0],
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={cerrarWizard}>Cancelar</Button>
        <Button
          variant="primary"
          disabled={
            !cvArchivo || !cedulaFrente || !cedulaReverso || !contratoArchivo ||
            (tieneExamenes && examenesSeleccionados.some(ex => !archivosExamenes[ex]))
          }
          onClick={async () => {
            const formData = new FormData();

            // Campos de usuario
            Object.entries(nuevoUsuario).forEach(([key, value]) => {
              console.log(`${key}: ${value}`);
              formData.append(key, value);
            });

            // Archivos obligatorios
            formData.append("cv", cvArchivo);
            formData.append("cedula_frente", cedulaFrente);
            formData.append("cedula_reverso", cedulaReverso);
            formData.append("contrato", contratoArchivo);

            // Exámenes seleccionados
            formData.append("examenes", JSON.stringify(examenesSeleccionados));
            examenesSeleccionados.forEach((examen) => {
              if (archivosExamenes[examen]) {
                formData.append(`archivo_examen_${examen}`, archivosExamenes[examen]);
              }
            });

            // 4. Foto perfil → AL FINAL
            if (previsualizacion) {
              formData.append("fotoPerfil", previsualizacion);
            }

            try {

              const response = await fetch(`${API}/crear_usuario`, {
                method: "POST",
                body: formData,
              });

              if (response.ok) {
                alert("Usuario creado correctamente.");
                cerrarWizard();
              } else {
                alert("Error al crear el usuario.");
              }
            } catch (error) {
              console.error("Error al enviar datos:", error);
              alert("Error de conexión con el servidor.");
            }
          }}
        >
          Finalizar
        </Button>

      </Modal.Footer>
    </Modal>

    {/* MODAL ACCIÓN USUARIO */}
      <Modal
        show={mostrarAccionModal}
        onHide={() => setMostrarAccionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            ¿Qué deseas hacer con <span className="text-primary">{usuarioAccion?.Usuario}</span>?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Button
            variant="primary"
            onClick={() => {
              setUsuarioSeleccionado(usuarioAccion);
              setUsuarioEditado({ ...usuarioAccion }); 
              setModoEdicion(true);
              setMostrarDetalleUsuario(true);
              setMostrarAccionModal(false);
            }}
          >
            Editar
          </Button>

          <Button
            variant="danger"
            onClick={() => {
              setUsuarioAEliminar(usuarioAccion);
              setMostrarAccionModal(false);
              setMostrarConfirmacionEliminar(true);
            }}
          >
            Eliminar
          </Button>
        </Modal.Body>
      </Modal>

    {/* MODAL ACCION USUARIO: EDITAR, DESVINCULAR, ELIMINAR */}             
    <Modal
      show={mostrarAccionModal}
      onHide={() => setMostrarAccionModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          ¿Qué deseas hacer con <span className="text-primary">{usuarioAccion?.Nombre} {usuarioAccion?.["Apellido Paterno"]}</span>?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <Button
          variant="primary"
          className="me-3"
          onClick={() => {
            setUsuarioEditado(usuarioAccion);  // ← cargamos al editable
            setModoEdicion(true);              // ← activamos modo edición
            setMostrarDetalleUsuario(true);    // ← abrimos tarjeta
            setMostrarAccionModal(false);      // ← cerramos modal de acción
          }}
        >
          Editar
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            setUsuarioAEliminar(usuarioAccion);
            setMostrarAccionModal(false);
            setMostrarConfirmacionEliminar(true);
          }}
        >
          Eliminar
        </Button>
      </Modal.Body>
    </Modal>

    {/* MODAL USUARIOS EXTERNOS */}  
    <Modal show={mostrarModalExternos} onHide={() => { setMostrarModalExternos(false); setModoIndividual(false); }} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">
          {modoIndividual ? "Agregar Usuario Externo" : "¿Cuántos usuarios deseas cargar?"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {!modoIndividual ? (
          <>
            <Button
              variant="outline-primary"
              className="w-100 mb-4 d-flex align-items-center justify-content-center"
              onClick={() => setModoIndividual(true)}
            >
              <i className="bi bi-person-fill me-2"></i> Individual
            </Button>
            <Button
              variant="outline-primary"
              className="w-100 d-flex align-items-center justify-content-center"
              onClick={() => {
                setMostrarModalExternos(false);
                setMostrarModalMultiples(true); // 👈 ACTIVA EL MODAL MULTIPLE
              }}
            >
              <i className="bi bi-people-fill me-2"></i> Múltiples
            </Button>
          </>
        ) : (
          <Form>
            {/* MODAL CARGA USUARIOS EXTERNOS INDIVIDUAL */}  
            <Form.Group className="mb-3 text-start">
              <Form.Label className="fw-bold">Nombre</Form.Label>
              <Form.Control type="text" required value={nombreExt} onChange={(e) => setNombreExt(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fw-bold">Apellido Paterno</Form.Label>
              <Form.Control type="text" required value={apellidoPExt} onChange={(e) => setApellidoPExt(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fw-bold">Apellido Materno</Form.Label>
              <Form.Control type="text" required value={apellidoMExt} onChange={(e) => setApellidoMExt(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fw-bold">Celular</Form.Label>
              <div className="d-flex align-items-center">
                <img
                  src={`https://flagcdn.com/w40/${prefijoPais.iso}.png`}
                  alt={prefijoPais.nombre}
                  width="24"
                  height="16"
                  className="me-2"
                />
                <Form.Select
                  style={{ maxWidth: "100px", marginRight: "10px" }}
                  value={prefijoPais.codigo}
                  onChange={(e) => {
                    const seleccion = paises.find(p => p.codigo === e.target.value);
                    setPrefijoPais(seleccion);
                  }}
                >
                  {paises.map((pais) => (
                    <option key={pais.codigo} value={pais.codigo}>
                      {pais.codigo}
                    </option>
                  ))}
                </Form.Select>

                <Form.Control
                  type="tel"
                  placeholder="Número sin prefijo"
                  value={celularExt}
                  onChange={(e) => setCelularExt(e.target.value)}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fw-bold">Correo Electrónico</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  type="text"
                  placeholder="usuario"
                  required
                  value={correoParte1}
                  onChange={(e) => setCorreoParte1(e.target.value)}
                />
                <span className="px-2">@</span>
                <Form.Select
                  required
                  value={correoDominio}
                  onChange={(e) => setCorreoDominio(e.target.value)}
                >
                  <option value="gmail.com">gmail.com</option>
                  <option value="outlook.com">outlook.com</option>
                  <option value="yahoo.com">yahoo.com</option>
                  <option value="hotmail.com">hotmail.com</option>
                </Form.Select>
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" className="me-2" onClick={() => setModoIndividual(false)}>
                Volver
              </Button>
              <Button onClick={handleEnviarIndividual}>Enviar</Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>

    {/* MODAL NUEVO PARA CARGA MÚLTIPLE */}
    <Modal show={mostrarModalMultiples} onHide={() => setMostrarModalMultiples(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Agregar Múltiples Usuarios</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <h5 className="fw-bold">Paso 1: Descargar archivo base para cargar usuarios</h5>
          <Button
            variant="outline-success"
            onClick={() => {
              const link = document.createElement("a");
              link.href = "/BaseCargaMultiple.xlsx"; // debe estar en public/
              link.download = "BaseCargaMultiple.xlsx";
              link.click();
            }}
          >
            Descargar plantilla Excel
          </Button>
        </div>

        <div className="mb-3">
          <h5 className="fw-bold">Paso 2: Completar planilla y cargarla aquí</h5>
          <Form.Group controlId="formArchivoExcel">
            <Form.Control type="file" accept=".xlsx,.xls" onChange={(e) => { console.log("📁 Archivo seleccionado:", e.target.files[0]); setArchivoExcelCargado(e.target.files[0]); }} />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setMostrarModalMultiples(false)}>
          Cancelar
        </Button>
        <Button variant="primary" disabled={!archivoExcelCargado} onClick={procesarArchivoExcel}>
          Procesar y Enviar Correos
        </Button>
      </Modal.Footer>
    </Modal>

    {/*MODAL PARA ELIMINAR USUARIO*/}       
    <Modal show={mostrarConfirmacionEliminar} onHide={() => setMostrarConfirmacionEliminar(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">¿Estás seguro?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="fw-bold mb-2">
          ¿Deseas eliminar a {usuarioAEliminar?.Nombre} {usuarioAEliminar?.["Apellido Paterno"]}?
        </p>
        <p className="text-muted" style={{ fontSize: "0.9rem" }}>
          Si realizas esta acción se eliminará todo registro del usuario en sistema, así como sus documentos y demáses.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setMostrarConfirmacionEliminar(false)}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={confirmarEliminacionUsuario}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>

    {/*MODAL PARA MOSTRAR-EDITAR DETALLES USUARIOS*/}   
    <Modal
      show={mostrarDetalleUsuario}
      onHide={() => setMostrarDetalleUsuario(false)}
      centered
      dialogClassName="modal-usuario-detalle"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {modoEdicion ? "Editar Usuario" : "Detalle del Usuario"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modoEdicion && (
          <div className="alert alert-warning text-center py-2 mb-4" role="alert">
            🔔 <strong>Estás en modo edición</strong>
          </div>
        )}

        <Form>
          <Row>

            <Col md={4} className="d-flex justify-content-center align-items-start">
              <div
                style={{
                  width: "100%",
                  height: "250px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  border: "2px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden"
                }}
              >
                {usuarioSeleccionado && usuarioSeleccionado.FotoPerfil ? (
                  <img
                    src={usuarioSeleccionado.FotoPerfil}
                    alt="Foto Usuario"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <span className="text-muted text-center">Foto no disponible</span>
                )}
              </div>
            </Col>


            {/* DATOS PRINCIPALES A LA DERECHA DE LA FOTO */}
            <Col md={8}>
              <div style={{ maxWidth: "500px" }}>
                {/* Nombre en fila completa */}
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    value={modoEdicion ? usuarioEditado?.Nombre || "" : usuarioSeleccionado?.Nombre || ""}
                    disabled={!modoEdicion}
                    onChange={(e) => manejarCambioCampo("Nombre", e.target.value)}
                    className={modoEdicion ? "border border-danger" : ""}
                  />
                </Form.Group>

                {/* Apellido Paterno y Apellido Materno en la misma fila */}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Apellido Paterno</Form.Label>
                      <Form.Control
                        type="text"
                        value={modoEdicion ? usuarioEditado?.["Apellido Paterno"] || "" : usuarioSeleccionado?.["Apellido Paterno"] || ""}
                        disabled={!modoEdicion}
                        onChange={(e) => manejarCambioCampo("Apellido Paterno", e.target.value)}
                        className={modoEdicion ? "border border-danger" : ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Apellido Materno</Form.Label>
                      <Form.Control
                        type="text"
                        value={modoEdicion ? usuarioEditado?.["Apellido Materno"] || "" : usuarioSeleccionado?.["Apellido Materno"] || ""}
                        disabled={!modoEdicion}
                        onChange={(e) => manejarCambioCampo("Apellido Materno", e.target.value)}
                        className={modoEdicion ? "border border-danger" : ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Correo y Celular en la misma fila */}
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Correo</Form.Label>
                      <Form.Control
                        type="text"
                        value={modoEdicion ? usuarioEditado?.Correo || "" : usuarioSeleccionado?.Correo || ""}
                        disabled={!modoEdicion}
                        onChange={(e) => manejarCambioCampo("Correo", e.target.value)}
                        className={modoEdicion ? "border border-danger" : ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Celular</Form.Label>
                      <Form.Control
                        type="text"
                        value={modoEdicion ? usuarioEditado?.Celular || "" : usuarioSeleccionado?.Celular || ""}
                        disabled={!modoEdicion}
                        onChange={(e) => manejarCambioCampo("Celular", e.target.value)}
                        className={modoEdicion ? "border border-danger" : ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* DATOS ADICIONALES BAJO LA FOTO */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Cargo</Form.Label>
                <Form.Control
                  type="text"
                  value={modoEdicion ? usuarioEditado?.Cargo || "" : usuarioSeleccionado?.Cargo || ""}
                  disabled={!modoEdicion}
                  onChange={(e) => manejarCambioCampo("Cargo", e.target.value)}
                  className={modoEdicion ? "border border-danger" : ""}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Área o Departamento</Form.Label>
                <Form.Control
                  type="text"
                  value={modoEdicion ? usuarioEditado?.["Área o Departamento"] || "" : usuarioSeleccionado?.["Área o Departamento"] || ""}
                  disabled={!modoEdicion}
                  onChange={(e) => manejarCambioCampo("Área o Departamento", e.target.value)}
                  className={modoEdicion ? "border border-danger" : ""}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Rol Usuario</Form.Label>
                <Form.Control
                  type="text"
                  value={modoEdicion ? usuarioEditado?.RolUsuario || "" : usuarioSeleccionado?.RolUsuario || ""}
                  disabled={!modoEdicion}
                  onChange={(e) => manejarCambioCampo("Rol Usuario", e.target.value)}
                  className={modoEdicion ? "border border-danger" : ""}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Estado</Form.Label>
                <Form.Control
                  type="text"
                  value={modoEdicion ? usuarioEditado?.Estado || "" : usuarioSeleccionado?.Estado || ""}
                  disabled={!modoEdicion}
                  onChange={(e) => manejarCambioCampo("Estado", e.target.value)}
                  className={modoEdicion ? "border border-danger" : ""}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="align-items-end">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Fecha Ingreso</Form.Label>
                <Form.Control
                  type="text"
                  value={modoEdicion ? usuarioEditado?.FechaIngreso || "" : usuarioSeleccionado?.FechaIngreso || ""}
                  disabled={!modoEdicion}
                  onChange={(e) => manejarCambioCampo("Fecha Ingreso", e.target.value)}
                  className={modoEdicion ? "border border-danger" : ""}
                />
              </Form.Group>
            </Col>

            {modoEdicion && (
              <>
                <Col md={3} className="mb-3">
                  <Button
                    variant="secondary"
                    className="w-100"
                    style={{ height: "42px" }}
                    onClick={() => {
                      setModoEdicion(false);
                      setMostrarDetalleUsuario(false);
                      setUsuarioSeleccionado(null);
                    }}
                  >
                    Cancelar
                  </Button>
                </Col>
                <Col md={3} className="mb-3">
                  <Button
                    variant="success"
                    className="w-100"
                    style={{ height: "42px" }}
                    disabled={!cambiosRealizados}
                    onClick={guardarCambiosUsuario}
                  >
                    Guardar
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </Modal.Body>
    </Modal>

    </div>
  );
};

export default GestionUsuarios;
